import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
    DistanceDisplayComponent,
    DurationDisplayComponent,
    ImageCdnSrcDirective,
} from '@polaris-customerweb/sharedcomponents.shared';
import {
    Geofence,
    PlannedRide,
    TrackedRide,
    UserContentItem,
    Waypoint,
} from '@polaris-customerweb/sharedcomponents.user-content';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Collection } from 'src/app/models/collection';
import { SnapshotToUrlPipe } from 'src/app/pipes/snapshot-to-url.pipe';
import { GeocoderService } from 'src/app/services/geocoder.service';
import { AreaDisplayComponent } from '../area-display/area-display.component';

@Component({
    imports: [
        AngularSvgIconModule,
        AreaDisplayComponent,
        DistanceDisplayComponent,
        DurationDisplayComponent,
        ImageCdnSrcDirective,
        MatCheckboxModule,
        NgClass,
        SnapshotToUrlPipe,
    ],
    selector: 'rdx-user-content-select-item',
    styleUrls: ['./user-content-select-item.component.scss'],
    templateUrl: './user-content-select-item.component.html',
})
export class UserContentSelectItemComponent implements OnInit {
    @Input() item: UserContentItem = new Collection();
    @Input() isSelected: boolean;

    @Output() itemSelected = new EventEmitter<UserContentItem>();

    isEmptyCollection = false;
    area: number;
    duration: number;
    itemCount: number;
    length: number;
    locationStrings: string[];

    constructor(private geocoderService: GeocoderService) {}

    ngOnInit(): void {
        this.isEmptyCollection =
            this.item instanceof Collection && !this.item.hasItems;

        if (this.item instanceof Collection) {
            this.itemCount = this.item.itemCount;
        }

        if (this.item instanceof Geofence) {
            this.area = this.item.area || 0;
        }

        if (this.item instanceof TrackedRide) {
            this.duration = this.item.totalDurationSeconds;
            this.length = this.item.totalLengthMeters;
        }

        if (this.item instanceof PlannedRide) {
            this.duration = this.item.ride.totalDurationInSeconds;
            this.length = this.item.ride.totalLengthInMeters;
        }

        if (this.item instanceof Waypoint) {
            this.geocoderService
                .getAddressByGeoCoordinate(this.item.geoCoordinate)
                .subscribe((address) => {
                    this.locationStrings =
                        this.geocoderService.getLocationString(
                            this.item.geoCoordinate,
                            address
                        );
                });
        }
    }
}
